import request from '@/services/request'
import { getApiUrl, getEventApiUrl } from '@/utils/tool'

export function login(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/login',
    method: 'post',
    data: object
  })
}
export function updateToken(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/update-token',
    method: 'post',
    data: object,
    customConfig: {
      mute: true,
      noLoading: true
    }
  })
}

export function getPhoneCode(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/get-phone-code',
    method: 'post',
    data: object
  })
}

export function getVerifyCode(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/get-verify-code',
    method: 'post',
    data: object
  })
}

export function verifyPhoneCode(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/verify-phone-code',
    method: 'post',
    data: object
  })
}

export function getEmailCode(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/get-email-code',
    method: 'post',
    data: object
  })
}

export function verifyEmailCode(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/verify-email-code',
    method: 'post',
    data: object
  })
}

export function resetPassword(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/reset-password',
    method: 'post',
    data: object
  })
}

export function forgotPassword(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/forgot-password',
    method: 'post',
    data: object
  })
}

export function requestForgotPassword(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/request-forgot-password',
    method: 'post',
    data: object
  })
}

export function validateCodInfo(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/validate-code-info',
    method: 'post',
    data: object
  })
}

export function register(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/register-and-login',
    method: 'post',
    data: object
  })
}

// 第三方登入後補設定 username（body 主動帶 2201 暫存的正式 token 驗證，及 username）
export function updateUsername(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/update-username',
    method: 'post',
    data: object
  })
}

export function gold() {
  return request({
    baseURL: getApiUrl(),
    url: '/user/gold',
    method: 'post'
  })
}
// 所有member pool的內容
export function goldInfo() {
  return request({
    baseURL: getApiUrl(),
    url: '/user/gold-info',
    method: 'post',
    customConfig: {
      noLoading: true
    }
  })
}

export function info(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/me',
    method: 'post',
    data: object,
    customConfig: {
      noLoading: true
    }
  })
}

export function update(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/update',
    method: 'post',
    data: object
  })
}

export function getLetter(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/get-letter',
    method: 'post',
    data: object
  })
}

export function setLetterRead(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/set-letter-read',
    method: 'post',
    data: object
  })
}

export function setAllLetterRead(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/set-all-letter-read',
    method: 'post',
    data: object
  })
}

export function getPromotionInfo() {
  return request({
    baseURL: getApiUrl(),
    url: '/user/get-promotion-info',
    method: 'post'
  })
}

export function getPromotionShortUrl() {
  return request({
    baseURL: getEventApiUrl(),
    url: '/short/',
    method: 'post'
  })
}

export function addFavoriteGame(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/add-favorite',
    method: 'post',
    data: object,
    customConfig: {
      noLoading: true
    }
  })
}
export function removeFavoriteGame(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/remove-favorite',
    method: 'post',
    data: object,
    customConfig: {
      noLoading: true
    }
  })
}

export function couponExchange(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/coupon-exchange',
    method: 'post',
    data: object
  })
}

export function KycReview(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/kyc-review',
    method: 'post',
    data: {
      member_id: object
    }
  })
}

export function usernameCheck(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/check-username ',
    method: 'post',
    data: object,
    customConfig: {
      mute: true,
      noLoading: true
    }
  })
}

export function phoneCheck(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/check-phone ',
    method: 'post',
    data: object,
    customConfig: {
      mute: true,
      noLoading: true
    }
  })
}

export function selfLimitLogin(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/self-limit-login',
    method: 'post',
    data: object
  })
}

export function getThirdPartyKycUrl(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/sumsub-request',
    method: 'post',
    data: object
  })
}

export function loginUseOptCode(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/user/login-opt',
    method: 'post',
    data: object
  })
}

export function getGoogleQrcode(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/google/get-qr-code',
    method: 'post',
    data: object
  })
}

export function updateGoogleStatus(object) {
  return request({
    baseURL: getApiUrl(),
    url: '/google/update-status',
    method: 'post',
    data: object
  })
}

